<script>
import CardBridgeUpload from './card-bridge-upload'
import ValidateMixin from './mixins/validate'

export default {
  name: 'RnrIdcard',
  components: { CardBridgeUpload },
  mixins: [ValidateMixin],
  props: {
    label: {
      type: String,
      default: ''
    },
    value: {
      type: Array,
      default: () => ([])
    },
    attrs: {
      type: Object,
      default: () => ({})
    },
    rules: {
      type: Array,
      default: () => ([])
    },
    compress: {
      type: Object,
      default: null
    },
    api: {
      type: Function,
      default: () => {}
    },
    validateCallback: {
      type: Function,
      default: null
    }
  },
  methods: {
    /**
     * 当图片发生改变的方法
     */
    handleImageChange(index, val) {
      // 重新赋值
      const value = [...this.value]
      value[index] = val[0]
      // 开始双向绑定
      this.$emit('input', value)
      // 触发改变方法
      this.$emit('change', value)
      // 等界面渲染完成后
      this.$nextTick(this.validate)
    }
  },
  render() {
    return (
      <div class='rnr-idcard'>
        <div class='idcard-image-wrapper'>
          <card-bridge-upload iType={1} compress={this.compress} value={this.value[0] ? [this.value[0]] : []} api={this.api} maxCount={1} onInput={val => this.handleImageChange(0, val)}>
            <div class='upload-wrapper idcard-front'>
              <div class='icon-upload-camera' />
            </div>
          </card-bridge-upload>
          <div class='idcard-label'>上传身份证的人像面</div>
        </div>
        <div class='idcard-image-wrapper'>
          <card-bridge-upload iType={2} compress={this.compress} value={this.value[1] ? [this.value[1]] : []} api={this.api} maxCount={1} onInput={val => this.handleImageChange(1, val)}>
            <div class='upload-wrapper idcard-back'>
              <div class='icon-upload-camera' />
            </div>
          </card-bridge-upload>
          <div class='idcard-label'>上传身份证的国徽面</div>
        </div>
      </div>
    )
  }
}
</script>

<style lang="scss">
.rnr-idcard {
  .idcard-image-wrapper {
    margin-top: 64px;
    .component-bridge-upload {
      display: flex;
      justify-content: center;
      .upload-wrapper {
        background-color: #F7F8FA;
        background-repeat: no-repeat;
        background-position: center;
        background-size: 100% 100%;
        width: 516px;
        height: 322px;
        position: relative;

        .icon-upload-camera {
          background-image: url(./assets/ico_camera.png);
          background-size: 100% 100%;
          position: absolute;
          width: 80px;
          height: 80px;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
        }

        &.idcard-front {
          background-image: url(./assets/ico_idcard_front.png);
        }
        &.idcard-back {
          background-image: url(./assets/ico_idcard_back.png);
        }
      }
      .van-uploader__input-wrapper {
        margin: 0 auto;
      }
      .van-uploader__preview {
        width: 516px;
        height: 322px;
        margin: 0 auto !important;
        overflow: hidden;
        .van-uploader__preview-image {
          width: 100% !important;
          height: 100% !important;
        }
        .van-uploader__preview-delete {
          background-color: rgba(0, 0, 0, .4);
          border-radius: 20px;
          display: flex;
          width: 40px;
          height: 40px;
          .van-uploader__preview-delete-icon {
            font-size: 60px;
            top: -10px;
            right: -10px;
          }
        }
        &:nth-child(3) {
          margin-right: 0px;
        }
      }
    }
    .idcard-label {
      color: rgba(36, 36, 36, 0.4);
      font-size: 24px;
      font-weight: 400;
      line-height: 33px;
      margin-top: 16px;
      text-align: center;
    }
    &:first-child {
      margin-top: 0;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/FormRender/idcard.vue